import { render, staticRenderFns } from "./NoFinancialServices.vue?vue&type=template&id=5a53881a&scoped=true"
import script from "./NoFinancialServices.vue?vue&type=script&lang=js"
export * from "./NoFinancialServices.vue?vue&type=script&lang=js"
import style0 from "./NoFinancialServices.vue?vue&type=style&index=0&id=5a53881a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a53881a",
  null
  
)

export default component.exports